import WebDAVRestService from "./WebDAVRestService"
import React from "react"
import { TFunction } from "i18next"

class WebDAVService {

    static async getAllConfigurations(setWebdavConfigurations: React.Dispatch<any>) {
        const webdavConfigurations = await WebDAVRestService.getAll()
        setWebdavConfigurations(webdavConfigurations)
    }

    static async createConfiguration(configuration: any, t: TFunction, setWebdavConfigurations: React.Dispatch<any>) {
        try {
            await WebDAVRestService.create(configuration)

            const webdavConfigurations = await WebDAVRestService.getAll()
            setWebdavConfigurations(webdavConfigurations)

            return t('webdav.createConfigurationSuccess', { name: configuration.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async editConfiguration(configuration: any, t: TFunction, setWebdavConfiguration: React.Dispatch<any>) {
        try {
            await WebDAVRestService.update(configuration)
            await WebDAVService.getAllConfigurations(setWebdavConfiguration)

            return t('webdav.updateSuccess', { name: configuration.name })
        } catch (error) {
            return Promise.reject(error)
        }

    }

    static async deleteConfiguration(configuration: any, t: TFunction, setWebdavConfiguration: React.Dispatch<any>) {
        try {
            await WebDAVRestService.delete(configuration.id)
            await WebDAVService.getAllConfigurations(setWebdavConfiguration)

            return t('webdav.deleteSuccess', { name: configuration.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getAllWebDAVpolicies(setWebDAVPolicies?: React.Dispatch<any>) {
        if (setWebDAVPolicies) {
            const webServicePolicies = await WebDAVRestService.getAllWebDAVPolicies()
            setWebDAVPolicies(webServicePolicies)
        } else {
            return WebDAVRestService.getAllWebDAVPolicies()
        }
    }

    static async createPolicy(webServicePolicy: any, t: TFunction, setWebDAVPolicies?: React.Dispatch<any>) {
        try {
            const createdPolicy = await WebDAVRestService.createWebDAVPolicy(webServicePolicy)
            if (setWebDAVPolicies) {
                const webServicePolicies = await WebDAVRestService.getAllWebDAVPolicies()
                setWebDAVPolicies(webServicePolicies)
            }
            return t('webdav.createWebDAVPolicySuccess', { name: createdPolicy.configName })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getPolicyById(id: number, setWebDAVPolicies?: React.Dispatch<any>) {
        if (setWebDAVPolicies) {
            const webServicePolicy = await WebDAVRestService.getById(id)
            setWebDAVPolicies(webServicePolicy)
        } else {
            return WebDAVRestService.getById(id)
        }
    }

    static async deletePolicy(policy: any, t: TFunction, setWebDAVPolicies?: React.Dispatch<any>) {
        try {
            await WebDAVRestService.deleteWebDAVPolicy(policy.id)
            if (setWebDAVPolicies) {
                const webServicePolicies = await WebDAVRestService.getAllWebDAVPolicies()
                setWebDAVPolicies(webServicePolicies)
            }
            return t('webdav.createWebDAVPolicySuccess', { name: policy.configName })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async updatePolicy(policy: any, t: TFunction, setWebDAVPolicies?: React.Dispatch<any>) {
        try {
            const editedPolicy = await WebDAVRestService.updateWebServicePolicy(policy)
            if (setWebDAVPolicies) {
                const policies = await WebDAVRestService.getAllWebDAVPolicies()
                setWebDAVPolicies(policies)
            }
            return t('webdav.editWebDAVPolicySuccess', { name: editedPolicy.configName })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async copyPolicy(row: any, t: TFunction, setWebDAVPolicies?: React.Dispatch<any>) {
        try {
            const editedPolicy = await WebDAVRestService.copyWebServicePolicy(row)
            if (setWebDAVPolicies) {
                const policies = await WebDAVRestService.getAllWebDAVPolicies()
                setWebDAVPolicies(policies)
            }
            return t('webdav.copyWebDAVPolicySuccess', { name: editedPolicy.configName })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async addTokenizerConfig(config: any, t: TFunction, setWebDAVPolicies?: React.Dispatch<any>) {
        try {
            const addedTokConfig = await WebDAVRestService.addTokenizerConfig(config)
            if (setWebDAVPolicies) {
                const tokenizerConfigs = await WebDAVRestService.getAllWebDAVPolicies()
                setWebDAVPolicies(tokenizerConfigs)
            }
            return t('testdata.tokenizerConfig.assignTokConfigSuccess', { configName: addedTokConfig.columnName })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async updateTokenizerConfig(config: any, t: TFunction, setWebDAVPolicies?: React.Dispatch<any>) {
        try {
            const editedTokConfig = await WebDAVRestService.updateTokenizerConfig(config)
            if (setWebDAVPolicies) {
                const tokenizerConfigs = await WebDAVRestService.getAllWebDAVPolicies()
                setWebDAVPolicies(tokenizerConfigs)
            }
            return t('testdata.tokenizerConfig.editTokConfigSuccess', { name: editedTokConfig.columnName })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async deleteTokenizerConfig(config: any, t: TFunction, setWebDAVPolicies?: React.Dispatch<any>) {
        try {
            await WebDAVRestService.deleteTokenizerConfig(config.id)
            if (setWebDAVPolicies) {
                const policies = await WebDAVRestService.getAllWebDAVPolicies()
                setWebDAVPolicies(policies)
            }
            return t('testdata.tokenizerConfig.deleteTokConfigSuccess', { name: config.columnName })
        } catch (error) {
            return Promise.reject(error)
        }
    }

} export default WebDAVService
